export interface IEnvironment {
    production: boolean;
    apiBaseUrl: string;
    phiBaseUrl: string;
    loginUrl: string;
    authAppUrl?: string;
    remitAppUrl: string;
    adminAppUrl: string;
    phiAppUrl: string;
    studiesAppUrl: string;
    clinicAppUrl: string;
    billerAppUrl: string;
    chartsAppUrl: string;
    signatureKey: string;
    preferredAdminCompanyId?: string;
    /** ask-aya-health — cleared via logout relay. */
    ayaAppUrl?: string;
    /** aya-health-chat (dev-www / qa-www / www) — final logout landing. */
    ayaHealthChatAppUrl?: string;
}

export enum AvailableApplication {
    Admin = 'admin',
    Remit = 'remit',
    Phi = 'phi',
    Biller = 'biller',
    Studies = 'studies',
    Charts = 'charts',
    Clinic = 'clinic',
    Vascunote = 'vascunote'
}